import { cva } from '@/styled-system/css';

export const containerRecipe = cva({
  base: {
    textAlign: 'center',
    alignItems: 'center',
    border: '1px solid {colors.border.subtle}',
    borderRadius: 'obj.default',
    color: 'text.neutral',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    padding: '200',
    transition: 'border 0.24s ease-in-out',
  },
  variants: {
    isContainerSizeFixed: {
      true: {
        height: '2500',
        width: '2500',
      },
      false: {
        height: '100%',
        width: '100%',
      },
    },
    isSmallDropzone: {
      true: {
        md: {
          // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minHeight: 90px` falls between `2200` (88px) and `2300` (92px) on the numeric sizes scale
          minHeight: '90px',
        },
      },
      false: {
        md: {
          // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minHeight: 240px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
          minHeight: '240px',
        },
      },
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 'disabled',
        backgroundColor: 'bg.softer',
      },
      false: {
        cursor: 'pointer',
        opacity: 'action.active',
      },
    },
    isDragAccept: {
      true: {
        border: '2px solid {colors.border.accent.brand.hero}',
        backgroundColor: 'bg.softer',
      },
      false: {},
    },
    isDragReject: {
      true: {
        border: '1px solid {colors.border.accent.red.hero}',
      },
      false: {},
    },
  },
});
